/**
 * - Description -
 * LoaderService contains all the methods that allows the webapp to make and handle loaders.
 *
 * - Usage -
 * Using LoaderService
 *
 * import LoaderService from '@/helpers/LoaderService.js';
 */
import store from '@/store';

export default {
    name: 'LoaderService',
    activateFullscreenLoader: activateFullscreenLoader,
    deactivateFullscreenLoader: deactivateFullscreenLoader
}

function activateFullscreenLoader(text) {
    let globalLoaderState = {
        activator: true,
        message: text,
    };
    store.dispatch("AppState/setGlobalLoaderState", globalLoaderState);
}

function deactivateFullscreenLoader() {
    let globalLoaderState = {
        activator: false,
        message: "",
    };
    store.dispatch("AppState/setGlobalLoaderState", globalLoaderState);
}
